import { Grid, makeStyles } from '@material-ui/core'
import InfoOutlined from 'components/common/icons/InfoOutlined'
import DazzedHeading14 from 'components/common/text/DazzedHeading14'
import Tooltip from 'components/common/Tooltip'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SparkleIcon from '../../icons/SparkleIcon'
import BaseWidget from '../../components/common/BaseWidget'
import RoundedLinearProgress from './CopilotUtilizationBar'
import CopilotUtilizationCategories from './CopilotUtilizationCategories'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px 20px',
    width: 250,
    borderRadius: 16
  },
  labelContainer: {
    wrap: 'nowrap',
    alignItems: 'center',
    paddingBottom: 10
  },
  tooltipContainer: {
    marginLeft: 5
  },
  tooltip: {
    maxWidth: '280px !important',
    borderRadius: 16,
    boxShadow: '0px 4px 4px 0px #00000040 !important'
  },
  iconContainer: {
    marginRight: 15
  }
}))

const CopilotUtilization = ({ practiceGuidelinesConfiguration }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const enabledCategories = practiceGuidelinesConfiguration.filter(category => category.isEnabled).length
  const utilizationValue = enabledCategories / practiceGuidelinesConfiguration.length

  return (
    <BaseWidget carousel={false} className={classes.root}>
      <Grid item className={classes.iconContainer}>
        <SparkleIcon />
      </Grid>
      <Grid container direction="column" wrap="nowrap">
        <Grid container className={classes.labelContainer}>
          <DazzedHeading14 regular>{t('pages.copilotControl.mainPage.copilotUtilization.title')}</DazzedHeading14>

          <Tooltip
            variant="light"
            value={<CopilotUtilizationCategories practiceGuidelinesConfiguration={practiceGuidelinesConfiguration} />}
            containerClassName={classes.tooltipContainer}
            tooltipContentClassName={classes.tooltip}
            placement="bottom"
            arrow
          >
            <InfoOutlined color="#727B8C" />
          </Tooltip>
        </Grid>
        <Grid item>
          <RoundedLinearProgress variant="determinate" value={utilizationValue * 100} />
        </Grid>
      </Grid>
    </BaseWidget>
  )
}

export default CopilotUtilization
